class GmSizechartModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const showBtn = this.querySelector("#video-btn");
    const modal = this.querySelector("#video-modal");
    const closeBtn = this.querySelector("#close-btn");

    showBtn.addEventListener("click", () => {
      modal.showModal();
      document.body.style.overflow = "hidden";
    });

    closeBtn.addEventListener("click", () => modal.close());

    modal.addEventListener("click", (event) => {
      const rect = modal.getBoundingClientRect();
      const isInModal =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (!isInModal) modal.close();
    });

    modal.addEventListener("close", () => {
      document.body.style.overflow = "auto";
    });
  }
}

customElements.define("gm-sizechart-modal", GmSizechartModal);